import { render, staticRenderFns } from "./BuildingFieldReferenceEditModal.vue?vue&type=template&id=412740e2&scoped=true&"
import script from "./BuildingFieldReferenceEditModal.vue?vue&type=script&lang=js&"
export * from "./BuildingFieldReferenceEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412740e2",
  null
  
)

export default component.exports